import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

export function useUpdateSimproCompanyIntegrationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, simproCompanyIntegrationParams }) => {
      const response = await axios.patch(
        `/integrations/simpro_company_integrations/${id}`,
        { simpro_company_integration: simproCompanyIntegrationParams },
      );
      return response.data;
    },
    onSuccess: (responseData) => {
      queryClient.setQueryData(
        ['integrations', 'simproCompanyIntegrations'],
        (existingDomainSimproCompanyIntegrations) =>
          produce(existingDomainSimproCompanyIntegrations, (draft) => {
            if (!draft) return draft;

            const index = draft.data.findIndex(
              (simproCompanyIntegration) =>
                simproCompanyIntegration.id === responseData.data.id,
            );

            if (index !== -1) draft.data[index] = responseData.data;
          }),
      );
    },
  });
}

export function useDestroySimproCompanyIntegrationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(
        `/integrations/simpro_company_integrations/${id}`,
      );
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.setQueryData(
        ['integrations', 'simproCompanyIntegrations'],
        (existingDomainSimproCompanyIntegrations) =>
          produce(existingDomainSimproCompanyIntegrations, (draft) => {
            if (!draft) return draft;

            const index = draft.data.findIndex(
              (simproCompanyIntegration) =>
                simproCompanyIntegration.id === variables.id,
            );

            if (index !== -1) draft.data.splice(index, 1);
          }),
      );
    },
  });
}
